<div class="d-flex flex-wrap bg-light toplineBlue">
  <nav class="nav p-2 border w-100">
    <a *ngFor="let route of routes; trackBy: trackByIndex"
       class="nav-link custom-link"
       [ngClass]="{'disabled': !route.enable}"
       [routerLink]="['/taxes', route.link]"
       routerLinkActive="active">
      {{ route.label }}
    </a>
  </nav>
</div>

<router-outlet></router-outlet>
